// #523: Rundungen der Oberfläche — drei Stufen (--r-s/--r-m/--r-l) und --r-pill, definiert in
// public/index.html. Welche Variante gilt, stellt der Super-Admin im Branding ein; hier wird sie
// am <html> gesetzt. Der letzte Stand liegt im Browser, damit beim nächsten Start nichts springt.

export type Rundung = 'A' | 'B' | 'C';
export const RUNDUNGEN: Rundung[] = ['A', 'B', 'C'];
export const RUNDUNG_VORGABE: Rundung = 'C';
const SPEICHER = 'rundung';

export const istRundung = (w: unknown): w is Rundung => typeof w === 'string' && (RUNDUNGEN as string[]).includes(w);

export function setzeRundung(r: Rundung): void {
  document.documentElement.dataset.rundung = r;
  try { localStorage.setItem(SPEICHER, r); } catch { /* privates Fenster */ }
}

export function ladeRundung(): void {
  try {
    const gemerkt = localStorage.getItem(SPEICHER);
    if (istRundung(gemerkt)) document.documentElement.dataset.rundung = gemerkt;
  } catch { /* privates Fenster */ }
  fetch('/api/branding/aussehen')
    .then(r => (r.ok ? r.json() : null))
    .then(j => { const r = j?.data?.rundung; if (istRundung(r)) setzeRundung(r); })
    .catch(() => { /* offline: gemerkter Stand bzw. Vorgabe C bleibt */ });
}
